/**
 * Polling options for the queue dashboard queries.
 *
 * `staleTime: 0` replaces the app default of 60s, so re-enabling a query when
 * a hidden tab becomes visible refetches immediately. `refetchInterval` is off
 * while `enabled` is false, so a hidden tab does not poll.
 *
 * TanStack Query v5 treats a document as focused when
 * `visibilityState !== 'hidden'`. A visible page already runs the interval.
 */
export const queueDashboardPollingOptions = (
  enabled: boolean,
  refreshInterval: number,
) => ({
  refetchInterval: (enabled ? refreshInterval : false) as number | false,
  staleTime: 0,
})
